<div class="container">
  <h3>Welcome to the service tester</h3>

  <p>To get started the service tester needs an endpoint to communicate with</p>

  <eva-endpoint-selector></eva-endpoint-selector>


</div>
